import { render, staticRenderFns } from "./OCrudDialog.vue?vue&type=template&id=14fc2520&scoped=true&"
import script from "./OCrudDialog.vue?vue&type=script&lang=js&"
export * from "./OCrudDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14fc2520",
  null
  
)

export default component.exports